import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/icons/bed-icon-black.png'
import _imports_1 from '@/assets/icons/bathtub-icon-black.png'
import _imports_2 from '@/assets/icons/car-icon-black.png'
import _imports_3 from '@/assets/icons/sofa-icon-black.png'


const _hoisted_1 = {
  key: 0,
  class: "house-features-wr"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.props.features)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(["icons", { 'reverse-icons': $setup.props.directionLogo, 'reverse-icons-center': $setup.props.directionLogoCalculator, 'reverse-icons-start': $setup.props.directionLogoLandPackage }])
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["icon-wr", { reverse: $setup.props.directionLogo || $setup.props.directionLogoCalculator || $setup.props.directionLogoLandPackage }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-text", { 'tiny-min': $setup.props.iconSize === 'tiny-min' }])
            }, _toDisplayString($setup.props.features.bedroom), 3),
            _createElementVNode("img", {
              class: _normalizeClass($setup.props.iconSize),
              src: _imports_0
            }, null, 2)
          ], 2),
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "line" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["icon-wr", { reverse: $setup.props.directionLogo || $setup.props.directionLogoCalculator || $setup.props.directionLogoLandPackage }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-text", { 'tiny-min': $setup.props.iconSize === 'tiny-min' }])
            }, _toDisplayString($setup.props.features.bathroom.quantity), 3),
            _createElementVNode("img", {
              class: _normalizeClass($setup.props.iconSize),
              src: _imports_1
            }, null, 2)
          ], 2),
          _cache[1] || (_cache[1] = _createElementVNode("div", { class: "line" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["icon-wr", { reverse: $setup.props.directionLogo || $setup.props.directionLogoCalculator || $setup.props.directionLogoLandPackage }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-text", { 'tiny-min': $setup.props.iconSize === 'tiny-min' }])
            }, _toDisplayString($setup.props.features.garage), 3),
            _createElementVNode("img", {
              class: _normalizeClass($setup.props.iconSize),
              src: _imports_2
            }, null, 2)
          ], 2),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "line" }, null, -1)),
          _createElementVNode("div", {
            class: _normalizeClass(["icon-wr", { reverse: $setup.props.directionLogo || $setup.props.directionLogoCalculator || $setup.props.directionLogoLandPackage }])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["icon-text", { 'tiny-min': $setup.props.iconSize === 'tiny-min' }])
            }, _toDisplayString($setup.props.features.loungeRoom.quantity), 3),
            _createElementVNode("img", {
              class: _normalizeClass($setup.props.iconSize),
              src: _imports_3
            }, null, 2)
          ], 2)
        ], 2),
        _renderSlot(_ctx.$slots, "button", {}, undefined, true)
      ]))
    : _createCommentVNode("", true)
}